
import { toast as sonnerToast } from "sonner";

// Define interface for toast options
interface ToastOptions {
  title?: string;
  description?: string;
  variant?: "default" | "destructive";
  duration?: number;
}

// Hook that provides a toast function
export function useToast() {
  const toast = ({ title, description, variant, duration }: ToastOptions) => {
    if (variant === "destructive") {
      sonnerToast.error(title || "", {
        description,
        duration: duration || 2000,
      });
    } else {
      sonnerToast(title || "", {
        description,
        duration: duration || 2000,
      });
    }
  };

  return { toast };
}

// Direct toast function for use without hooks
export const toast = (options: ToastOptions) => {
  const { title, description, variant, duration } = options;
  
  if (variant === "destructive") {
    sonnerToast.error(title || "", {
      description,
      duration: duration || 2000,
    });
  } else {
    sonnerToast(title || "", {
      description,
      duration: duration || 2000,
    });
  }
};
